import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useEvaluators } from "./hooks/useEvaluators";
import { EvaluatorsView } from "./components/EvaluatorsView";

export default function EvaluatorsPage() {
  const { groupId } = useParams<{ groupId?: string }>();

  const {
    evaluators,
    isLoading,
    isSubmitting,
    isCreating,
    selectedEvaluator,
    handleSelectEvaluator,
    handleStartCreate,
    handleCancelCreate,
    handleCreate,
    handleUpdate,
    handleDelete,
  } = useEvaluators({ selectedGroupId: groupId });

  // Auto-select the first evaluator so the detail pane isn't a big empty space
  // on landing (016 §5 / review §5.6). Skips while creating or already selected.
  useEffect(() => {
    if (!isLoading && !isCreating && !groupId && evaluators.length > 0) {
      handleSelectEvaluator(evaluators[0].group_id);
    }
  }, [isLoading, isCreating, groupId, evaluators, handleSelectEvaluator]);

  return (
    <EvaluatorsView
      groupId={groupId}
      evaluators={evaluators}
      isLoading={isLoading}
      isSubmitting={isSubmitting}
      isCreating={isCreating}
      selectedEvaluator={selectedEvaluator}
      onSelectEvaluator={handleSelectEvaluator}
      onStartCreate={handleStartCreate}
      onCancelCreate={handleCancelCreate}
      onCreate={handleCreate}
      onUpdate={handleUpdate}
      onDelete={handleDelete}
    />
  );
}
